"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Session extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'session';
        this._created = initParams.created;
        this._completed = initParams.completed;
        this._cancelled = initParams.cancelled;
        this._subscriptionItems = (0, util_1.camelArray)(initParams.subscription_items);
        this._physicalItems = (0, util_1.camelArray)(initParams.physical_items);
    }
    set created(value) {
        console.error('Do not set objects this way');
    }
    setCreated(value) {
        return this.dataService.updateSession(this.id, { created: value }, this);
    }
    get created() {
        return this._created;
    }
    set completed(value) {
        console.error('Do not set objects this way');
    }
    setCompleted(value) {
        return this.dataService.updateSession(this.id, { completed: value }, this);
    }
    get completed() {
        return this._completed;
    }
    set cancelled(value) {
        console.error('Do not set objects this way');
    }
    setCancelled(value) {
        return this.dataService.updateSession(this.id, { cancelled: value }, this);
    }
    get cancelled() {
        return this._cancelled;
    }
    set subscriptionItems(value) {
        console.error('Do not set objects this way');
    }
    setSubscriptionItems(value) {
        return this.dataService.updateSession(this.id, { subscription_items: (0, util_1.snakeArray)(value) }, this);
    }
    get subscriptionItems() {
        return this._subscriptionItems;
    }
    set physicalItems(value) {
        console.error('Do not set objects this way');
    }
    setPhysicalItems(value) {
        return this.dataService.updateSession(this.id, { physical_items: (0, util_1.snakeArray)(value) }, this);
    }
    get physicalItems() {
        return this._physicalItems;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateSession(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteSession(this.id, this);
    }
}
exports.default = Session;
//# sourceMappingURL=session.js.map